import * as Yup from 'yup';
import { t } from '@lingui/macro';
import { IsValidDanishCVR } from '~/app/shared/util/utilities/cvrUtils';
import { Company } from '~/app/pages/admin/central/types';

const validationSchema = (isAdministrator: boolean, isInternalAgreement: boolean, formValues: Company) =>
    Yup.object({
        name: Yup.string().required(),
        address1: Yup.string().required(),
        address2: Yup.string().nullable(),
        zipCode: Yup.string().required(),
        city: Yup.string().required(),

        country: Yup.string().nullable(),
        phone: Yup.string().nullable(),
        fax: Yup.string().nullable(),
        mobilePhone: Yup.string().nullable(),

        contact: Yup.string().when('_', {
            is: () => !isInternalAgreement,
            then: Yup.string().required(),
        }),
        email: Yup.string()
            .email(t`Invalid e-mail address`)
            .when('_', {
                is: () => !isInternalAgreement,
                then: Yup.string().required(),
            }),
        homepage: Yup.string().nullable(),

        invoiceToEmail: Yup.string()
            .email(t`Invalid e-mail address`)
            .when('_', {
                is: () => !isInternalAgreement,
                then: Yup.string().required(),
            }),
        cvr: Yup.string().test('cvr', t`Please enter a valid CVR number containing 8 digits.`, function (value) {
            if (this.parent.cvr !== formValues.cvr) {
                return isAdministrator || IsValidDanishCVR(value);
            }
            return true;
        }),
        linkText: Yup.string().nullable(),
        enforce2FA: Yup.boolean().nullable(),
        enableCustomerAnonymization: Yup.boolean().nullable(),
        canAdministratorToggleModulesSuperUser: Yup.boolean().nullable(),
        canCompanyToggleModulesSuperUser: Yup.boolean().nullable(),
        canNonPayingSuperUserManageUsers: Yup.boolean().nullable(),
    });

export default validationSchema;
